import {useMutation} from '@tanstack/react-query';
import {evaluateInquiry} from '@/api/help/my-inquiry';
import {goLogin} from '@/utils/main';

interface UseEvaluateInquiryProps {
  onSuccess: () => void;
}

export const useEvaluateInquiry = ({onSuccess}: UseEvaluateInquiryProps) => {
  return useMutation({
    mutationFn: evaluateInquiry,
    onError: () => {
      alert('처리 중 오류가 발생했습니다.');
    },
    onSuccess: ({errorCode}, {isMember}) => {
      if (errorCode === 0) {
        onSuccess();
        alert('만족도 참여 완료 하였습니다.');
      }
      // 이미 만족도 평가에 참여했을 때
      else if (errorCode === -1025) {
        alert('이미 참여 하였습니다.');
      }
      // 평가하려는 문의가 회원문의인데 로그인 안 된 상태로 평가할 때
      else if (errorCode === -2008) {
        if (isMember === 'Y') {
          alert('문의하신 계정으로 로그인이 필요합니다.');
          goLogin();
        }
      } else {
        alert('처리 중 오류가 발생했습니다.' + errorCode);
      }
    },
  });
};
